// Get current page SEO
export default async function ({ $api, route }) {
  try {
    const { path } = route
    await $api.seo.show(path)
  } catch (error) {
    console.log(`Ocorreu um erro ao executar o middleware 'seo': ${error}`)
  }
}
